import { SaveButton } from "react-admin";

function CustomSaveButton() {
  return <SaveButton variant="fieldwire-primary" />;
}

export default CustomSaveButton;
